export default {"src":"/_next/static/media/beam.9e709479.svg","height":27,"width":74,"blurWidth":0,"blurHeight":0};